import React from 'react';
import { ArrowRight } from 'lucide-react';
interface InlineCTAProps {
  text: string;
}
export function InlineCTA({
  text
}: InlineCTAProps) {
  return <div className="py-4 md:py-8 flex justify-center px-5" data-id="element-49">
      <a href="#offer-cta" className="
          inline-flex items-center justify-center gap-2
          bg-[#C75C3A] hover:bg-[#b04f30] text-white
          font-medium text-lg px-8 py-4 rounded-full
          transition-all duration-300 ease-in-out
          shadow-[0_4px_14px_0_rgba(199,92,58,0.39)]
          hover:shadow-[0_6px_20px_rgba(199,92,58,0.23)]
          hover:-translate-y-0.5
          w-full md:w-auto min-h-[48px]
          no-underline
        " data-id="element-50">
        {text}
        <ArrowRight className="w-5 h-5" data-id="element-51" />
      </a>
    </div>;
}